export function bookDropDownClose() {

    $(".book-drop-down .close-popup, .book-drop-down-overlay").on('click', function () {
        if ($(this).closest('#vue-root').length === 0) {
            $(".book-drop-down-wrap").removeClass('opened');
        }
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/bookDropDownCloseWithoutVue.js